import { Modal, Image, Button } from "react-bootstrap";
import React from "react";

const ItemModal = ({
  show,
  setShowModal,
  item,
  defaultTextColor,
  subtextStyle,
  defaultTextPriceColor,
  normalTextStyle,
  currencySymbol,
}) => {
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <span
              style={{
                color: defaultTextPriceColor,
                ...normalTextStyle,
              }}
            >
              {item.name}
            </span>{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p
            style={{
              marginBottom: 0,
              color: defaultTextColor,
              ...subtextStyle,
            }}
            className="mt-1 pr-3"
          >
            {`${item?.vintage || ""} ${item?.format || ""}`}
          </p>
          <br />
          <p
            className="font-italic"
            style={{
              color: defaultTextPriceColor,
              ...normalTextStyle,
            }}
          >
            {currencySymbol}
            {item.price}
          </p>
          <p style={{ textAlign: "center" }}>
            {item.imageUrl && (
              <Image
                src={item.imageUrl}
                fluid
                rounded
                style={{ height: "200px" }}
              />
            )}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ItemModal;
